<template>
  <div class="mobile-app-page">
    <div class="mobile-app-phone">
      <div class="mobile-app-lock">
        <div class="mobile-app-title">{{ $t('PRIVATE_CONTENT').Exclusive_Subscribers }}</div>
        <div class="mobile-app-subtitle">{{ $t('MOBILE_APP').Text }}</div>
        <vs-button v-if="showGooglePlay" class="mobile-app-button" @click.stop="openStore('app_google_play_url')">{{ $t('MOBILE_APP').Google_Play }}</vs-button>
        <vs-button v-if="showAppStore" class="mobile-app-button" @click.stop="openStore('app_apple_store_url')">{{ $t('MOBILE_APP').App_Store }}</vs-button>
      </div>
    </div>
    <div class="mobile-app-benefits">
      <h2 class="mb-5 mobile-app-benefits-title">{{ $t('PRIVATE_CONTENT').Smart_Content_Title }}</h2>
      <ul>
        <li>🔎 {{ $t('PRIVATE_CONTENT').Smart_Content_L1 }}</li>
        <li>💰 {{ $t('PRIVATE_CONTENT').Smart_Content_L2 }}</li>
        <li>📊 {{ $t('PRIVATE_CONTENT').Smart_Content_L3 }}</li>
        <li>🌎 {{ $t('PRIVATE_CONTENT').Smart_Content_L4 }}</li>
        <li>📈 {{ $t('PRIVATE_CONTENT').Smart_Content_L5 }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import checkDeviceTypeHelper from '../../helpers/check-device-type-helper';

export default {
  computed: {
    // Android mostra a Google Play, iOS a App Store; outros dispositivos mostram as duas lojas
    showGooglePlay() {
      return !checkDeviceTypeHelper.isPlatformIOS();
    },
    showAppStore() {
      return !checkDeviceTypeHelper.isPlatformAndroid();
    },
  },
  methods: {
    openStore(configKey) {
      // Links vem do config.json carregado em tempo de execucao
      const url = this.$config && this.$config[configKey];
      if (url) {
        window.location.href = url;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-app-page {
  min-height: 100vh;
  padding: 20px 10px 50px;
  background-color: #fff;
  background-image: url('/back.svg');
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
}

.theme-dark .mobile-app-page {
  background-color: #282e34;
  background-image: url('/backblack.svg');
}

.mobile-app-phone {
  background-image: url('/smartphone.png');
  min-height: 640px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  text-align: center;
}

.mobile-app-lock {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 250px;
  padding-top: 80px;
  color: #fff;
}

.mobile-app-title {
  font-weight: bold;
  font-size: 2rem;
  line-height: 28px;
  margin-bottom: 20px;
}

.mobile-app-subtitle {
  font-size: 1.5rem;
  line-height: 22px;
  margin-top: 15px;
  margin-bottom: 30px;
}

.mobile-app-button {
  width: 100%;
  margin-bottom: 20px;
  padding: 1rem 0.5rem !important;

  ::v-deep .vs-button-text {
    font-size: 1.2rem !important;
    line-height: 24px;
    text-transform: uppercase;
    font-weight: bold;
  }
}

.mobile-app-benefits {
  line-height: 30px;
  font-size: 1.1rem;
  margin: 20px auto 0;
  padding: 20px;
  width: fit-content;
  max-width: 100%;
  background-color: #efefef;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.mobile-app-benefits-title {
  text-align: center;
}

.theme-dark .mobile-app-benefits {
  background-color: var(--theme-surface-base);
  border: 1px solid var(--theme-surface-secondary);
}

.theme-dark .mobile-app-benefits-title,
.theme-dark .mobile-app-benefits li {
  color: #fff;
}
</style>
